import React from 'react';

import {
  Breadcrumbs,
  BusinessContactForm,
  BusinessTariffsCard,
  InternetBanner,
  TextBlock,
} from '@/ui/index';

import { Questions } from '../../roaming';

import styles from './Sms.module.scss';

const Sms = ({ data }) => {
  return (
    <div>
      {data?.breadcrumbs && <Breadcrumbs data={data.breadcrumbs} dark />}
      {data?.mainBanner && (
        <InternetBanner bannerData={data.mainBanner} dark medium />
      )}
      <div className={'wrapper'}>
        <TextBlock className={styles.text}>
          With roaming call packages from Bakcell, you can travel to more than
          50 countries and enjoy value-for-money rates every time you
          make/receive calls. All Bakcell subscribers can benefit from any
          roaming packages.
        </TextBlock>
      </div>
      {data?.offers && <BusinessTariffsCard data={data.offers} />}
      {data?.questions && (
        <Questions
          title={null}
          className={'wrapper section'}
          questions={data.questions}
        />
      )}
      {data?.banner && <BusinessContactForm bannerData={data?.banner} />}
    </div>
  );
};

export default Sms;
